(function () {
  'use strict';

  angular
      .module('tfc.Reports')
      .factory('Reports', Reports);

  // @ngInject
  function Reports($q, Api, util, Month, Upload, PageSize, $cacheFactory, Auth) {

    var BASE_URL = '/report';
    var cache = $cacheFactory('Reports');

    function reportUrl(id) {
      return BASE_URL + '/' + encodeURIComponent(id);
    }

    return {
      get : get,
      findAll : findAll,
      find : find,
      content : content,
      upload : upload,
      update : update,
      delete : deleteReport,
      audit : audit,
      reportCount : getReportCount,
      tlaFilterReport: getTlaFilterReport,
      defaultTla: getDefaultTla
    };

    function get(id) {
      return Api.get(reportUrl(id), { cache : cache }).then(unpack);
    }

    function findAll() {
      return Api.get(BASE_URL, { cache : cache }).then(unpack);
    }

    function getReportParams(tla, category, year, itemsPerPage, pageNumber, searchText) {
      var params = {
        tla: tla,
        category: category,
        year: year,
        itemsPerPage: itemsPerPage || PageSize,
        pageNumber: pageNumber || 1
      };

      if(searchText)
        params = _.extend(params, {searchText: searchText});

      return params;
    }
    
    function findReports(tla, category, year, itemsPerPage, pageNumber, searchText) {
      return function (apiFactory) {
        return apiFactory.get(BASE_URL, {
          cache : cache,
          params : getReportParams(tla, category, year, itemsPerPage, pageNumber, searchText)
        }).then(unpack);
      }
    }

    function find(tla, category, year, itemsPerPage, pageNumber, searchText) {
      return findReports(tla, category, year, itemsPerPage, pageNumber, searchText)(Api);
    }

    function reportContent(id, embed) {
      return function (apiFactory) {
        var params = {};
        if (embed) {
          params.embed = true;
        }
        return apiFactory.get(reportUrl(id) + '/content', {
          cache : true, // Can always cache content
          params : params,
          responseType : 'arraybuffer'
        }).then(function (response) {
          // parse the header as a map
          var disposition = util.parseMultipartHeader(response.headers('content-disposition'));
          return $q.all({
            fileName: disposition.filename,
            dataBlob: new Blob([response.data], { type : disposition['content-type'] })
          });
        });
      }
    }

    function content(id, embed) {
      return reportContent(id, embed)(Api);
    }

    function upload(report) {
      var data = _.pick(report, ['tla', 'category', 'file', 'isActive', 'sendEmail']);
      var key = getKey(report);
      return Upload.upload({
        method : 'POST',
        url : Api.getBasePath() + BASE_URL,
        data : _.extend(data, key)
      }).then(clearCache);
    }

    function getKey(report) {
      var d = report.date;

      function getYear(d) {
        return d.getYear() + 1900;
      }
      switch (report.category) {
        case 'week':
          return {
            year : getYear(d),
            month : Month.getMonth(d),
            day : d.getDate()
          };
        case 'month':
          return {
            year : getYear(d),
            month : Month.getMonth(d)
          };
        case 'quarter':
          return {
            year : getYear(d),
            quarter : report.quarter
          };
        case 'other':
          return {
            name : report.name
          };
        default:
          throw new Error('Unsupported report category [' + report.category + ']');
      }
    }

    function update(report) {
      return Api.put(reportUrl(report.fileKey), { isActive : report.isActive, sendEmail : report.sendEmail }).then(clearCache);
    }

    function deleteReport(id) {
      return Api.delete(reportUrl(id)).then(clearCache);
    }

    function audit(id) {
      return Api.get(reportUrl(id) + '/audit').then(unpack);
    }

    function unpack(response) {
      return response.data;
    }

    function clearCache(response) {
      cache.removeAll();
      return response.data;
    }
    
    function reportCount(tla, category, year, itemsPerPage, pageNumber, searchText) {
      return function (apiFactory) {
        return apiFactory.get(BASE_URL + '/count', {
          cache : cache,
          params : getReportParams(tla, category, year, itemsPerPage, pageNumber, searchText)
        }).then(unpack);
      }
    }

    function getReportCount(tla, category, year, itemsPerPage, pageNumber, searchText){
      return reportCount(tla, category, year, itemsPerPage, pageNumber, searchText)(Api);
    }

    function getTlaFilterReport(params){
      return Api.get(BASE_URL + '/tree', {
        cache : cache,
        params: params
      }).then(unpack);
    }

    function getDefaultTla(tla) {
      var tla = tla;
      if (!tla) {
        var user = Auth.getUser();
        tla = user.storeTlas[0];
      }
      return tla;
    }
  }

})();
